export const Marquee = ({ items }) => (
  <div
    className="overflow-hidden border-y border-hairline bg-paper-deep py-4 select-none"
    data-testid="editorial-marquee"
  >
    <div className="flex w-max animate-marquee">
      {[0, 1].map((half) => (
        <div key={half} aria-hidden={half === 1} className="flex shrink-0 items-center">
          {items.map((item, i) => (
            <span key={i} className="flex items-center whitespace-nowrap">
              <span className="px-7 font-serif italic text-lg text-soot">{item}</span>
              <span className="text-vermilion text-xs" aria-hidden="true">◆</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
